// Modal Content, This content is mainly used for Modal wrap with MainModal.tsx Component
import React from "react";
import { InputField } from "./InputField";
import cover from "../assets/images/Rectangle 18156.png";
import PrimaryButton from "./PrimaryButton";
import { PiTranslateBold } from 'react-icons/pi';
import { GrFormEdit } from "react-icons/gr";

interface EditDetailsModalProps {
  showNext?: () => void;
}

const EditDetailsModal = ({showNext}:  EditDetailsModalProps) => {
  return (
    <>
      <p className="text-[#9392A2] text-xs font-medium tracking-tight">You can change language or other parameters.</p>
      <p className="text-[#9392A2] text-xs font-medium tracking-tight mt-5">Name of the file</p>
      <div className="my-2">
        <InputField label="Video name" />
      </div>
      <img src={cover} className="w-full h-[300px] my-4" alt="cover" />
      <div className="flex items-center justify-between mb-4">
        <div>
          <p className="text-[#0F0C18] text-base font-medium tracking-tight">15:32</p>
          <p className="text-[#9392A2] text-xs font-medium tracking-tight">15 Mb • MP4</p>
        </div>
        <div className="flex items-center gap-1">
          <PiTranslateBold className="text-[#9392A2]" />
          <p className="text-[#9392A2] text-xs font-medium tracking-tight">English</p>
          <GrFormEdit className="text-[#0F0C18]" />
        </div>
      </div>
      <div className="flex items-center gap-2">
        <PrimaryButton className="w-full py-2 rounded-3xl" label="Back" black />
        <PrimaryButton onClick={() => showNext && showNext()} className="w-full py-2 rounded-3xl" label="Confirm" />
      </div>
    </>
  );
};

export default EditDetailsModal;